import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  z-index: 1;
  opacity: 40%;
  bottom: 2rem;
  right: 2rem;
  font-size: 2rem;
  transition: opacity 150ms;

  &:hover {
    opacity: 100%;
    cursor: pointer;
  }
`;
